// API Configuration
// API_BASE_URL is injected at build time via VITE_API_BASE_URL environment variable.
// Set it in .env.production before building. See frontend/deploy.sh.

if (!import.meta.env.VITE_API_BASE_URL) {
  console.error('VITE_API_BASE_URL is not set. Set it in .env.production before building.');
}

export const API_BASE = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');
export const API_GATEWAY_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');

// Default fetch options for API calls
export const DEFAULT_FETCH_OPTIONS = {
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'include'
};

// API endpoints configuration
export const API_ENDPOINTS = {
  auth: {
    currentUser: '/auth/user',
    samlInitiate: '/auth/saml/initiate',
    samlCallback: '/auth/saml/callback',
    manualLogin: '/auth/manual-login',
    logout: '/auth/logout'
  },
  admin: {
    users: '/admin/users',
    scimConfig: '/admin/scim-config',
    scimToken: '/admin/scim-token',
    scimLogs: '/admin/scim-logs',
    scimGroups: '/admin/scim-groups',
    budgets: '/admin/budgets',
    programs: '/admin/programs',
    applications: '/admin/applications',
    reports: '/admin/reports',
    cloudAccounts: '/admin/cloud-accounts',
    iacStateSources: '/admin/iac-state-sources',
    cloudServices: '/admin/cloud-services',
    cloudServicesSpend: '/admin/cloud-services/spend-summary',
    samlConfig: '/admin/saml-config',
    testSaml: '/admin/test-saml',
    costsRefresh: '/admin/costs/refresh',
    riRefresh: '/admin/costs/ri-refresh',
    syncAccount: '/admin/costs/sync-account',
    cancelSync: '/admin/costs/cancel-sync'
  },
  costs: {
    summary: '/costs/summary',
    marketplace: '/costs/marketplace',
    platform: '/costs/platform',
    byApplication: '/costs/by-application',
    byProvider: '/costs/by-provider',
    topServices: '/costs/top-services',
    records: '/costs/records',
    accountDetail: '/costs/account-detail',
    syncStatus: '/costs/sync-status',
    accounts: '/costs/accounts',
    migrationEstimate: '/costs/migration-estimate',
    forecast: '/costs/forecast',
    byAccount: '/costs/by-account',
    monthlyTrend: '/costs/monthly-trend',
    anomalies: '/costs/anomalies',
    riRecommendations: '/costs/ri-recommendations',
    tagKeys: '/costs/tag-keys',
    byTag: '/costs/by-tag',
    applicationTrend: '/costs/application-trend',
    applicationServices: '/costs/application-services'
  },
  inventory: {
    summary: '/inventory/summary',
    resources: '/inventory/resources'
  },
  utilization: {
    syncLogs: '/utilization/sync-logs'
  },
  ai: {
    analyze: '/ai/analyze',
    optimize: '/ai/optimize',
    explain: '/ai/explain',
    chat: '/ai/chat'
  }
};
